const { VITE_APP_PASSENTRY_API_URL: API_URL } = import.meta.env;

export { API_URL };
